'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import FullSenderName from '../senders/components/FullSenderName';
import Separator from '../atoms/Separator';
import CommentActions from './CommentActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIIcon = styled(UIIcon).withConfig({
  displayName: "CommentMessageHeader__StyledUIIcon",
  componentId: "noedux-0"
})(["margin-right:4px;"]);
class CommentMessageHeader extends PureComponent {
  renderMetadata() {
    const {
      isLoading,
      sender,
      timestamp,
      senderName
    } = this.props;
    if (isLoading) {
      return /*#__PURE__*/_jsx(SkeletonText, {
        "data-test-id": "skeleton",
        width: 200,
        use: "on-shade"
      });
    }
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.commentMessageSubject',
      style: {
        fontSize: 12
      },
      options: {
        name: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FullSenderName, {
            senderName: senderName,
            sender: sender
          })
        }),
        timestamp: /*#__PURE__*/_jsxs(Small, {
          "data-test-id": "comment-message-timestamp",
          children: [/*#__PURE__*/_jsx(Separator, {}), /*#__PURE__*/_jsx(FormattedDateTime, {
            value: timestamp,
            format: "LT",
            type: "userTz"
          })]
        })
      }
    });
  }
  render() {
    const {
      isHovered
    } = this.props;
    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "start",
      justify: "between",
      direction: "row",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        align: "start",
        justify: "between",
        direction: "column",
        wrap: "wrap",
        children: [this.props.renderHeaderMetadata ? this.props.renderHeaderMetadata() : this.renderMetadata(), /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: 'conversations-inbox-message-history.commentMessageTooltip',
          style: {
            fontSize: 12
          },
          options: {
            icon: /*#__PURE__*/_jsx(StyledUIIcon, {
              name: "view",
              size: 12
            })
          }
        })]
      }), isHovered && this.props.handleClickToDelete ? /*#__PURE__*/_jsx(CommentActions, {
        handleClickToDelete: this.props.handleClickToDelete,
        onClickToDeleteComment: this.props.onClickToDeleteComment
      }) : null]
    });
  }
}
CommentMessageHeader.displayName = 'CommentMessageHeader';
CommentMessageHeader.propTypes = {
  handleClickToDelete: PropTypes.func,
  isHovered: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClickToDeleteComment: PropTypes.func,
  renderHeaderMetadata: PropTypes.func,
  sender: RecordPropType('Sender'),
  senderName: PropTypes.node,
  timestamp: PropTypes.number
};
CommentMessageHeader.defaultProps = {
  isHovered: false
};
export default CommentMessageHeader;